import { onReady } from './util/onReady';
import { initDropdown, initSubNavbar } from '@bi-digital/react/vanilla';

onReady(() => {
    const subNavbar = document.querySelector<HTMLElement>('.business-review-header');
    if (!subNavbar) return;

    initSubNavbar();

    const dropdownButtons = subNavbar.querySelectorAll<HTMLButtonElement>(`button[aria-controls]`);

    dropdownButtons.forEach((dropdownButton) => {
        const dropdownId = dropdownButton.getAttribute('aria-controls');
        if (!dropdownId) return;

        initDropdown({ id: dropdownId, placement: 'bottom-start', padding: 0 });
    });
});
